import client from './client';

export const listAnnouncements = () => client.get('/announcements').then((r) => r.data);
export const activeAnnouncements = () => client.get('/announcements/active').then((r) => r.data);
export const createAnnouncement = (payload) => client.post('/announcements', payload).then((r) => r.data);
export const removeAnnouncement = (id) => client.delete(`/announcements/${id}`).then((r) => r.data);
export const ackAnnouncement = (id) => client.post(`/announcements/${id}/ack`).then((r) => r.data);
export const announcementAcks = (id) => client.get(`/announcements/${id}/acks`).then((r) => r.data);
